import { useMemo } from 'react';

import { usePagination } from '@/shared/hooks/usePagination';

import type { TagDetailItem } from '@/entities/tags';

import { useTagsByCategoryDetail } from '@/features/tags/model';

type UseTagCategoryTableDataParams = {
  selectedTagCategory: string;
  debouncedQuery: string;
  provider?: 'system' | 'user';
};

const getTableRowData = (tagsData: TagDetailItem[]) => {
  if (!tagsData) return [];
  return tagsData.map((tag) => {
    const { id, name, displayName, description, fullyQualifiedName, provider } = tag;
    return {
      key: id,
      id,
      name,
      displayName,
      description,
      fullyQualifiedName,
      provider,
    };
  });
};

export const useTagCategoryTableData = ({
  selectedTagCategory,
  debouncedQuery,
  provider,
}: UseTagCategoryTableDataParams) => {
  const { data: tagsData, isLoading } = useTagsByCategoryDetail({
    parent: selectedTagCategory ?? '',
    query: debouncedQuery,
    provider,
  });

  const transformedTagsData = useMemo(() => getTableRowData(tagsData?.data ?? []), [tagsData]);

  const { paginationConfig, scrollConfig } = usePagination({
    dataLength: transformedTagsData.length,
    viewportOffset: 548,
  });

  return {
    data: transformedTagsData,
    total: tagsData?.paging.total ?? 0,
    isLoading,
    paginationConfig,
    scrollConfig,
  };
};
